import {
    Grid,
    GridProps,
    Text,
} from '@chakra-ui/react';
import {
    Image,
} from 'shared';
import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { Link } from 'shared/ui/Link';
import { CartAddButtonWithCounter } from 'features';

export type DeliveryArticleCardProps = {
    uid: string
    name: string
    weight?: number
    price?: number
    currencyAbbreviation?: string
    link: {
        to: string,
    },
    image?: {
        src: string
    }
} & GridProps

export const DeliveryArticleCard: React.FC<DeliveryArticleCardProps> = ({
    uid,
    image,
    weight,
    price,
    currencyAbbreviation,
    name,
    link,
    ...props
}) => (
    <Grid
        gap="2rem"
        templateRows="1fr auto"
        {...props}
    >
        <Link to={link.to || ''}>
            <Grid
                gap="2rem"
                templateRows="auto 1fr"
                {...props}
            >
                <Image
                    src={image?.src}
                    aspectRatio="1 / 1"
                    objectFit="cover"
                />
                <Grid
                    templateRows="auto 1fr"
                >
                    <Grid
                        gap="2rem"
                        templateColumns="1fr auto"
                    >
                        <Text
                            fontSize="1rem"
                        >
                            Вес:
                            {' '}
                            {weight}
                            г
                        </Text>
                        <Text
                            fontSize="2rem"
                        >
                            {price?.toLocaleString()}
                            {currencyAbbreviation}
                        </Text>
                    </Grid>
                    <Text
                        height="fit-content"
                        fontSize="1.5rem"
                        fontWeight="bold"
                        textDecoration="underline"
                    >
                        {name}
                    </Text>
                </Grid>
            </Grid>
        </Link>
        <CartAddButtonWithCounter
            type="delivery"
            uid={uid}
        />
    </Grid>
);
